import { Injectable } from '@angular/core';
import { AuthorizeGuard } from '@platform/auth/authorize.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { UserManagementGuard } from './user-management.guard';

@Injectable({
  providedIn: 'root',
})
export class UserManagementCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthorizeGuard, userListGuard: UserManagementGuard) {
    super([authGuard, userListGuard]);
  }
}
